import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo4_Nuno } from '../../../../../utils/ES/Modals/directors';

const ModalVideoNuno4 = () => {
  return (
    <>
      <ModalVideo
        id="nuno-video-4"
        dataText={TextVideo4_Nuno}
        videoSrc="https://player.vimeo.com/video/770306684?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_NUNO_4"
      />
    </>
  );
};

export default ModalVideoNuno4;
